var map = {
	"./__tests__/locale.spec": [
		84050,
		9,
		4050
	],
	"./__tests__/locale.spec.ts": [
		84050,
		9,
		4050
	],
	"./en": [
		93523,
		3,
		3523
	],
	"./en--ADV": [
		39470,
		3,
		9470
	],
	"./en--ADV.json": [
		39470,
		3,
		9470
	],
	"./en--GAT": [
		38244,
		3,
		8244
	],
	"./en--GAT.json": [
		38244,
		3,
		8244
	],
	"./en--UB": [
		6166,
		3,
		6166
	],
	"./en--UB.json": [
		6166,
		3,
		6166
	],
	"./en.json": [
		93523,
		3,
		3523
	],
	"./en_CA": [
		36336,
		3,
		6336
	],
	"./en_CA--ADV": [
		6933,
		3,
		6933
	],
	"./en_CA--ADV.json": [
		6933,
		3,
		6933
	],
	"./en_CA--GAT": [
		64236,
		3,
		4236
	],
	"./en_CA--GAT.json": [
		64236,
		3,
		4236
	],
	"./en_CA--UB": [
		15073,
		3,
		5073
	],
	"./en_CA--UB.json": [
		15073,
		3,
		5073
	],
	"./en_CA.json": [
		36336,
		3,
		6336
	],
	"./en_US": [
		91123,
		3,
		1123
	],
	"./en_US--ADV": [
		75702,
		3,
		5702
	],
	"./en_US--ADV.json": [
		75702,
		3,
		5702
	],
	"./en_US--GAT": [
		4638,
		3,
		4638
	],
	"./en_US--GAT.json": [
		4638,
		3,
		4638
	],
	"./en_US--UB": [
		21407,
		3,
		1407
	],
	"./en_US--UB.json": [
		21407,
		3,
		1407
	],
	"./en_US.json": [
		91123,
		3,
		1123
	],
	"./i18n-context-provider/I18NContextProvider": [
		86156,
		9,
		6156
	],
	"./i18n-context-provider/I18NContextProvider.tsx": [
		86156,
		9,
		6156
	],
	"./i18n-context-provider/I18NContextProviderClient": [
		78457,
		9
	],
	"./i18n-context-provider/I18NContextProviderClient.tsx": [
		78457,
		9
	],
	"./locale-merge": [
		58525,
		9
	],
	"./locale-merge.ts": [
		58525,
		9
	],
	"./localization": [
		44356,
		9
	],
	"./localization-auto-generated": [
		13150,
		9,
		3150
	],
	"./localization-auto-generated.ts": [
		13150,
		9,
		3150
	],
	"./localization.ts": [
		44356,
		9
	],
	"./structured-clone": [
		58926,
		9
	],
	"./structured-clone.ts": [
		58926,
		9
	],
	"./types": [
		42087,
		9,
		2087
	],
	"./types.ts": [
		42087,
		9,
		2087
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 66888;
module.exports = webpackAsyncContext;